import axios from './client'
import {
  LabelFilters,
  LabelsResponse,
  LabelResponse,
  LabelsStatsResponse
} from '../types/label'

function buildLabelParams(filters: Omit<LabelFilters, 'release_ids'>): URLSearchParams {
  const params = new URLSearchParams()
  Object.entries(filters).forEach(([key, value]) => {
    if (value == null) return
    if (Array.isArray(value)) {
      value.forEach(item => params.append(key, String(item)))
    } else {
      params.set(key, String(value))
    }
  })
  return params
}

export async function getLabels(filters: LabelFilters = {} as LabelFilters): Promise<LabelsResponse> {
  const { release_ids, ...queryFilters } = filters
  if (release_ids && release_ids.length > 0) {
    const { data } = await axios.post('/labels/search', { release_ids, ...queryFilters })
    return data
  }
  const { data } = await axios.get('/labels', { params: buildLabelParams(queryFilters) })
  return data
}

export async function getLabel(name: string): Promise<LabelResponse> {
  const { data } = await axios.get(`/labels/${encodeURIComponent(name)}`)
  return data
}

export async function getLabelsStats(): Promise<LabelsStatsResponse> {
  const { data } = await axios.get('/labels/stats')
  return data
}

export interface LabelSuggestion {
  name: string
}

export async function getLabelSuggestions(q: string): Promise<LabelSuggestion[]> {
  const { data } = await axios.get('/labels/suggest', { params: { q } })
  return data.suggestions || []
}
